/**
 * Active-build brand identity. GENERATED from brands/phavella.json by scripts/gen-brand-ts.mjs —
 * regenerated by scripts/rebrand.mjs when producing a twin. Components read brand strings from
 * here, never hardcoded, so the rebrand stays a data swap. Colors live in the generated CSS.
 */
export const brand = {
  id: "phavella",
  name: "phavella",
  company: "phavella",
  productName: "creativeOS",
  tagline: "Your business, supercharged.",
  url: "https://phavella.com",
  contactUrl: "https://phavella.com/contact",
  logoUrl: "/brand-logo.svg",
  defaultMode: "light",
  analyticsSite: "demo:creativeos:phavella",
  version: "v1.1",
  copy: {
    lockedTitle: "This step runs live for clients",
    lockedBody: "This step uses paid AI models and is gated in the public demo. Here's a real sample the platform produced — book a walkthrough to run it live on your own inputs.",
    lockedCta: {
      label: "Book a walkthrough",
      href: "https://phavella.com/contact"
    }
  }
} as const

export type Brand = typeof brand
